import dayjs, { Dayjs } from 'dayjs';
import { isCypress } from './is-cypress.util';

if (!isCypress()) {
    const utc = require('dayjs/plugin/utc');
    dayjs.extend(utc);

    const advancedFormat = require('dayjs/plugin/advancedFormat');
    const isSameOrAfter = require('dayjs/plugin/isSameOrAfter');
    const isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
    const isToday = require('dayjs/plugin/isToday');
    dayjs.extend(isToday);
    dayjs.extend(isSameOrAfter);
    dayjs.extend(isSameOrBefore);
    dayjs.extend(advancedFormat);
}
export const dayjsEx = dayjs;
export type DayjsEx = Dayjs;
